module.exports = __webpack_public_path__ + "img/reveal-tasting-min.65a96f42.jpg";